import * as yup from "yup";
import { validate } from "@";
import type { DriverFormValues } from "../types.ts";
import { driverPermissionsDefaults } from "./permissions";

// ============================================
// Driver Validation Schemas
// ============================================

export const driverCreateSchema = yup
  .object({
    name: validate("req"),
    password: validate("password"),
    phoneNumber: validate("phone"),
  })
  .required();

export const driverEditSchema = yup
  .object({
    name: validate("req"),
  })
  .required();

export const driverDefaultValues: DriverFormValues = {
  id: null,
  name: "",
  password: "",
  phoneNumber: "",
  permissions: driverPermissionsDefaults,
};
